import {useEffect, useState} from 'react';
import { getStartOfDayTimestamp } from '../../../../../Apis/functions';
import { GetFreeShedules } from '../../../../../reduxToolkit/EmployeeEvents/EmployeeEventsApi';
import {useDispatch, useSelector} from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
const ScheduleLocationApp = ({ eventDetail, setEventDetail, handleChange }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { getEventSetting } = useSelector((state) => state?.EmployeeEventsSlice);
    const [bodyForExport, setBodyForExport] = useState();
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [results, setResults] = useState(false);

    const [modalBookSpace, setModalBookSpace] = useState(false);
    const [allFreeReservation, setAllFreeReservation] = useState([]);


    /**
     * Handle validate to get data
     */
    useEffect(() => {
        if (eventDetail?.dateSelected) {
            handleApiFreeSchedules();
        }
    }, [eventDetail?.dateSelected]);


    /**
     * Handle to get data for get free schedules by date selected
     */
    const handleApiFreeSchedules = () => {
        const fromTime = getStartOfDayTimestamp(eventDetail.dateSelected);
        const freeSchedulesDto = {
            fromTime,
            zoneId: eventDetail?.zoneSelected?.zoneId,
        };
        dispatch(GetFreeShedules(freeSchedulesDto)).then(({ payload: { data: { data, success } } }) => {
                if (success) {
                    setAllFreeReservation(
                        data.map(item => ({
                            ...item,
                            selected: false
                        }))
                    );
                }
            },
        );
    };

    /**
     * Handle to click en the table and set data
     * @param item
     */
    const handleClickItem = (item) => {
        handleChange({ target: { value: item, name: "zoneSelected" } })
        setModalBookSpace(true);
    }

    /**
     * Event that validates the choice of available times for the event
     * @param index
     */
    const handleSelectSlot = (index) => {
        setAllFreeReservation((prev) => {
            let selectedIndexes = prev
                .map((item, i) => (item.selected ? i : null))
                .filter(i => i !== null);

            let updatedSelection;

            if (selectedIndexes.includes(index)) {
                updatedSelection = selectedIndexes.filter(i => i !== index);
            } else {
                const firstSelected = selectedIndexes[0];
                const lastSelected = selectedIndexes[selectedIndexes.length - 1];

                if (
                    selectedIndexes.length === 0 ||
                    Math.abs(firstSelected - index) === 1 ||
                    Math.abs(lastSelected - index) === 1
                ) {
                    updatedSelection = [...selectedIndexes, index];
                } else {
                    updatedSelection = [index];
                }
            }

            updatedSelection.sort((a, b) => a - b);

            const isConsecutive = updatedSelection.every((val, i, arr) => {
                if (i === 0) return true;
                return val === arr[i - 1] + 1;
            });

            if (!isConsecutive) {
                updatedSelection = [index];
            }

            return prev.map((item, i) => ({
                ...item,
                selected: updatedSelection.includes(i),
            }));
        });
    };

    /**
     * Event that validates if at least one time has been selected for the event
     */
    const handleConfirmSelectSlot = () => {
        const selectedItems = allFreeReservation
            .map((item, index) => ({ ...item, index }))
            .filter(item => item.selected);

        if (selectedItems.length > 0) {
            selectedItems.sort((a, b) => a.index - b.index);

            const hourStart = selectedItems[0].fromTime;
            const hourEnd = selectedItems[selectedItems.length - 1].toTime;

            setEventDetail(prev => ({
                ...prev,
                bookingSelected: {
                    from: hourStart,
                    to: hourEnd,
                    duration: (selectedItems?.length || 0) * 30
                }
            }));

            setAllFreeReservation([]);
            setModalBookSpace(false);

        } else {
            toast.warn(t('select_hour_error'));
        }
    };

    return {t,
        setBodyForExport, setSearch, setSimpleSearch,
        results, setResults,
        searchElement, setSearchElement,
        modalBookSpace, setModalBookSpace,
        allFreeReservation, setAllFreeReservation,
        getEventSetting,
        handleClickItem,
        handleSelectSlot,
        handleConfirmSelectSlot
    }

}

export default ScheduleLocationApp
